// extracted by extract-css-chunks-webpack-plugin
module.exports = {"window":"window_Z9TIW","window__separator":"window__separator_P6S6I"};